import { defineStore } from "pinia";
import Router from './../routes';
import Http from '../utils/http';
import Utils from '../utils/utils';
import i18n from '../localizations';
import { useRootStore } from "./root";

export const useDocumentsStore = defineStore("documents", {
    state: () => ({
        documents: [],
        documentTypes: [],
        documentSubTypes: [],
        templates: [],
        editedDocument: null
    }),

    actions: {
        addDocuments(documents) {
            documents.forEach(document => this.documents.push({
                id: document.id,
                name: document.name,
                type: document.type,
                content: document.content
            }));
        },

        clearDocuments() {
            this.documents = [];
        },

        setEditedDocument(document) {
            this.editedDocument = {
                id: document['id'],
                templateId: document['template_id'],
                name: document['name'],
                type: document['type'],
                subtype: document['subtype'],
                content: document['content'],
                locale: document['locale']
            };
        },

        addDocumentTypes(documentTypes) {
            documentTypes.forEach(documentType => this.documentTypes.push(documentType));
        },

        clearDocumentTypes() {
            this.documentTypes = [];
        },

        setDocumentSubTypes(documentSubTypes) {
            this.documentSubTypes = [];

            documentSubTypes.forEach(subType => this.documentSubTypes.push(subType));
        },

        clearState() {
            this.$reset();
        },
        
        loadDocuments() {
            Http.get('/api/documents')
                .then(response => {
                    const documents = response.data || [];

                    this.clearDocuments();
                    this.addDocuments(documents)
                })
                .catch(error => console.error(error));
        },

        loadDocument(documentId) {
            Http.get(`/api/documents/${documentId}`)
                .then(response => {
                    const document = response.data;
                    this.setEditedDocument(document);
                })
                .catch(error => console.error(error));
        },

        loadDocumentTypes() {
            Http.get('/api/documents/types')
                .then(response => {
                    const documentTypes = response.data || [];

                    this.clearDocumentTypes();
                    this.addDocumentTypes(documentTypes);
                })
        },

        loadDocumentSubTypes(payload) {
            const templateId = payload['template_id'];

            if (payload['template_id'] !== undefined)
                delete payload['template_id'];

            Http.post(`/api/templates/${templateId}/document-subtypes`, payload)
                .then(response => this.setDocumentSubTypes(response.data))
                .catch(error => console.error(error));
        },

        loadDocumentsByType(documentType) {
            Http.get(`/api/documents/types/${documentType}`)
                .then(response => {
                    const documents = response.data || [];

                    this.clearDocuments();
                    this.addDocuments(documents);
                })
                .catch(error => console.error(error));
        },

        createDocument(document) {
            const rootStore = useRootStore();
            
            Http.post('/api/documents', document)
                .then(response => {
                    const document = response.data;
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.document_successfully_created', { documentName: document['name'] })
                    );

                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    Router.push('/documents', null);
                })
                .catch(error => Utils.resolveValidationErrors(error))
        },

        updateDocument(document) {
            const documentId = document.id;

            if (document.id !== undefined)
                delete document.id;

            const rootStore = useRootStore();
                
            Http.put(`/api/documents/${documentId}`, document)
                .then(response => {
                    const document = response.data;
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.document_successfully_edited', { documentName: document['name'] })
                    );

                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    Router.push('/documents', null);
                })
                .catch(error => Utils.resolveValidationErrors(error))
        },

        deleteDocument(documentId) {
            const rootStore = useRootStore();
            
            Http.delete(`/api/documents/${documentId}`)
                .then(response => {
                    const document = response.data || [];
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.document_successfully_deleted', { documentName: document['name'] })
                    );

                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    this.loadDocuments();
                })
                .catch(error => console.error(error));
        }
    }
})